import { HttpContextToken } from '@angular/common/http';

export const LOG_CONTENT = new HttpContextToken<string>(() => '');
